import { flashLeonardo } from './avr109.js';

// --- AUTH STATE ---
let isAuthenticated = false;

// --- DOM REFS ---
const connectBtn = document.getElementById('connectBtn');
const clearBtn = document.getElementById('clearBtn');
const copyBtn = document.getElementById('copyBtn');
const output = document.getElementById('output');
const serialStatus = document.getElementById('serialStatus');
const flashBtn = document.getElementById('flashBtn');
const hexFileInput = document.getElementById('hexFile');
const flashStatus = document.getElementById('flashStatus');
const hexLockOverlay = document.getElementById('hexLockOverlay');
const showLoginBtn = document.getElementById('showLoginBtn');
const loginModal = document.getElementById('loginModal');
const closeLoginModal = document.getElementById('closeLoginModal');
const loginForm = document.getElementById('loginForm');
const loginError = document.getElementById('loginError');
const authBadge = document.getElementById('authBadge');

// --- CHECK AUTH ON LOAD ---
async function checkAuth() {
    try {
        const resp = await fetch('/api/auth-status');
        const data = await resp.json();
        isAuthenticated = data.authenticated;
    } catch {
        isAuthenticated = false;
    }

    if (isAuthenticated) {
        // Hide lock overlay, enable hex section
        if (hexLockOverlay) hexLockOverlay.classList.add('hidden');
        if (connectBtn) {
            connectBtn.disabled = false;
            connectBtn.className = 'inline-flex items-center justify-center rounded-xl bg-[#ed4245] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#c7383a] focus:outline-none focus:ring-2 focus:ring-[#ed4245] focus:ring-offset-2 focus:ring-offset-[#23272a]';
        }
        if (clearBtn) {
            clearBtn.disabled = false;
            clearBtn.className = 'inline-flex items-center justify-center rounded-xl bg-white px-6 py-3 text-sm font-semibold text-[#111214] transition hover:bg-[#e3e5e8] focus:outline-none focus:ring-2 focus:ring-white/70 focus:ring-offset-2 focus:ring-offset-[#23272a]';
        }
        if (copyBtn) {
            copyBtn.disabled = false;
            copyBtn.className = 'inline-flex items-center justify-center rounded-xl bg-white px-6 py-3 text-sm font-semibold text-[#111214] transition hover:bg-[#e3e5e8] focus:outline-none focus:ring-2 focus:ring-white/70 focus:ring-offset-2 focus:ring-offset-[#23272a]';
        }
    } else {
        // Show lock overlay, disable hex section
        if (hexLockOverlay) hexLockOverlay.classList.remove('hidden');
        if (connectBtn) {
            connectBtn.disabled = true;
            connectBtn.className = 'inline-flex items-center justify-center rounded-xl bg-[#3a3f45] px-6 py-3 text-sm font-semibold text-[#949ba4] cursor-not-allowed';
        }
        if (clearBtn) {
            clearBtn.disabled = true;
            clearBtn.className = 'inline-flex items-center justify-center rounded-xl bg-[#3a3f45] px-6 py-3 text-sm font-semibold text-[#949ba4] cursor-not-allowed';
        }
        if (copyBtn) {
            copyBtn.disabled = true;
            copyBtn.className = 'inline-flex items-center justify-center rounded-xl bg-[#3a3f45] px-6 py-3 text-sm font-semibold text-[#949ba4] cursor-not-allowed';
        }
    }
}

checkAuth();

// --- LOGIN MODAL ---
if (showLoginBtn) {
    showLoginBtn.onclick = () => {
        loginModal.classList.remove('hidden');
        loginError.classList.add('hidden');
    };
}

if (closeLoginModal) {
    closeLoginModal.onclick = () => {
        loginModal.classList.add('hidden');
    };
}

// Click outside modal to close
loginModal.addEventListener('click', (e) => {
    if (e.target === loginModal) {
        loginModal.classList.add('hidden');
    }
});

if (loginForm) {
    loginForm.onsubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData(loginForm);
        loginError.classList.add('hidden');
        try {
            const resp = await fetch('/api/login', { method: 'POST', body: fd });
            const data = await resp.json();
            if (resp.ok) {
                loginModal.classList.add('hidden');
                checkAuth();
            } else {
                loginError.textContent = data.error || 'Login failed';
                loginError.classList.remove('hidden');
            }
        } catch {
            loginError.textContent = 'Network error';
            loginError.classList.remove('hidden');
        }
    };
}

// --- SERIAL CONFIG ---
let port = null;
let reader = null;
let keepReading = true;

// --- Discord webhook batch buffer ---
let webhookBatch = [];
let webhookTimer = null;
const WEBHOOK_BATCH_SIZE = 10;
const WEBHOOK_FLUSH_INTERVAL = 2000;

function flushWebhook() {
    if (webhookBatch.length === 0) return;
    const batch = webhookBatch.splice(0);
    const payload = batch.join('\n');

    fetch('/api/webhook', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: payload
    }).catch(() => {});
}

function queueHexLine(line) {
    if (!line || line.trim() === '') return;
    webhookBatch.push(line);

    if (webhookBatch.length >= WEBHOOK_BATCH_SIZE) {
        if (webhookTimer) {
            clearTimeout(webhookTimer);
            webhookTimer = null;
        }
        flushWebhook();
    } else if (!webhookTimer) {
        webhookTimer = setTimeout(() => {
            webhookTimer = null;
            flushWebhook();
        }, WEBHOOK_FLUSH_INTERVAL);
    }
}

if (clearBtn) {
    clearBtn.onclick = () => { output.textContent = ''; };
}

if (copyBtn) {
    copyBtn.onclick = () => {
        navigator.clipboard.writeText(output.textContent);
        const t = copyBtn.textContent;
        copyBtn.textContent = '✅ Copied';
        setTimeout(() => copyBtn.textContent = t, 1000);
    };
}

if (connectBtn) {
    connectBtn.onclick = async () => {
        if (port) {
            keepReading = false;
            if (reader) await reader.cancel();
            await port.close();
            port = null;
            connectBtn.textContent = '🔌 Connect Serial';
            if (isAuthenticated) {
                connectBtn.className = 'inline-flex items-center justify-center rounded-xl bg-[#ed4245] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#c7383a] focus:outline-none focus:ring-2 focus:ring-[#ed4245] focus:ring-offset-2 focus:ring-offset-[#23272a]';
            }
            serialStatus.textContent = 'Serial: Disconnected';
            serialStatus.className = 'status idle';
            return;
        }
        try {
            port = await navigator.serial.requestPort();
            await port.open({ baudRate: 115200 });
            connectBtn.textContent = '🔌 Disconnect';
            connectBtn.className = 'inline-flex items-center justify-center rounded-xl bg-[#c7383a] px-6 py-3 text-sm font-semibold text-white transition';
            serialStatus.textContent = 'Serial: Reading...';
            serialStatus.className = 'status success';
            keepReading = true;
            output.textContent = '';
            const decoder = new TextDecoderStream();
            port.readable.pipeTo(decoder.writable);
            reader = decoder.readable.getReader();
            while (keepReading) {
                const { value, done } = await reader.read();
                if (done) break;
                if (value) {
                    output.textContent += value;
                    output.scrollTop = output.scrollHeight;
                    queueHexLine(value);
                }
            }
        } catch (e) {
            serialStatus.textContent = 'Serial Error: ' + e.message;
            serialStatus.className = 'status error';
        }
    };
}

// --- FLASH CONFIG ---
if (flashBtn) {
    flashBtn.onclick = async () => {
        if (!hexFileInput.files.length) return alert('Please choose a .hex file');

        try {
            flashStatus.textContent = 'Status: Preparing...';
            flashStatus.className = 'status working';
            flashBtn.disabled = true;

            const file = hexFileInput.files[0];

            await flashLeonardo(file, {
                onProgress: (msg) => {
                    flashStatus.textContent = 'Status: ' + msg;
                    flashStatus.className = 'status working';
                }
            });

            flashStatus.textContent = 'Flash 100% success!';
            flashStatus.className = 'status success';
            flashBtn.disabled = false;
        } catch (e) {
            flashStatus.textContent = 'Error: ' + e.message;
            flashStatus.className = 'status error';
            flashBtn.disabled = false;
        }
    };
}

// Check Web Serial API support
if (!('serial' in navigator)) {
    if (serialStatus) {
        serialStatus.textContent = 'Error: Browser does not support Web Serial';
        serialStatus.className = 'status error';
    }
    if (connectBtn) connectBtn.disabled = true;
    if (flashBtn) flashBtn.disabled = true;
}